<template>
    <slot name="form-customer" v-bind="this"></slot>
</template>


<script>

import FormValidator from "lib/form-validator.mjs";


export default {
    props: {
        editCustomerUrl: { type: String, required: false },
        csrfToken: { type: String, required: true },
        customer: { type: String, required: true },
        customerIndex: { type: String, required: false },
    },
    data() {
        return {
            formValidator: new FormValidator({
                firstName: {
                    required: true,
                    type: 'string-copy',
                    min: 3,
                    max: 20
                },
                lastName: {
                    required: true,
                    type: 'string-copy',
                    min: 3,
                    max: 20
                },
                telephone: {
                    required: true,
                    type: 'number',
                    min: 10,
                    max: 13,
                },
            }, {
                firstName: '',
                lastName: '',
                telephone: '',
            }),

            errors: {
                firstName: { init: 1 },
                lastName: { init: 1 },
                telephone: { init: 1 },
            },

            firstName: this.customer.firstName || '',
            lastName: this.customer.lastName || '',
            email: this.customer.email || '',
            telephone: this.customer.telephone || '',

            showAlert:  false,

        }
    },
    watch: {
        firstName(val) {
            this.formValidator.setValue('firstName', val).then(
                () => {
                    this.hideError('firstName');
                    this.evaluateButtonStatus();
                },
                (error) => {
                    this.showError('firstName', error);
                    this.evaluateButtonStatus();
                }
            );
        },

        lastName(val) {
            this.formValidator.setValue('lastName', val).then(
                () => {
                    this.hideError('lastName');
                    this.evaluateButtonStatus();
                },
                (error) => {
                    this.showError('lastName', error);
                    this.evaluateButtonStatus();
                }
            );
        },

        telephone(val) {
            this.formValidator.setValue('telephone', val).then(
                () => {
                    this.hideError('telephone');
                    this.evaluateButtonStatus();
                },
                (error) => {
                    this.showError('telephone', error);
                    this.evaluateButtonStatus();
                }
            );
        },

    },
    methods: {
        hideError(name) {
            this.errors[name] = {}
        },
        showError(name, error) {
            this.errors[name] = {};
            this.errors[name][error] = true;
        },
        evaluateButtonStatus() {
            for( let error in this.errors ){
                    if( Object.keys( this.errors[ error ] ).length > 0 ){
                        this.submitLock = true;
                        return;
                    }
                }
            this.submitLock = false;
        },

        handleEditCustomerProfile(e) {
            e.preventDefault();


            this.$emit( 'wait', true );

            const formData = new FormData();
            formData.append('firstName', this.firstName)
            formData.append('lastName', this.lastName)
            formData.append('telephone', this.telephone)
            formData.append('_token', this.csrfToken)

            fetch(this.editCustomerUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'Accept': 'application/json',
                }
            })
            .then(response => {
                return response.json().then(data => {
                    if(!response.ok) throw data;
                    return data;
                });
            })
            .then(data => {
                this.showAlert = true;
            })
            .catch(error => {
                console.log(error.message)
                this.$emit( 'wait', false);
            })

        },

        validatePhoneNumber(e) {
            const allowedCharsRegex = /^[0-9]*\+?[0-9]*$/;

            if (!allowedCharsRegex.test(e.key)) {
                e.preventDefault();
                return;
            }

            if (e.key === '+') {
                if (e.target.value.includes('+') || e.target.selectionStart !== 0) {
                e.preventDefault();
                }
            }
        },

        allowOnlyLetters(e) {
            const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/;
            if(!regex.test(e.key)) {
                e.preventDefault();
            }
        },

        removeExtraSpaces(field, event) {
            const newValue = event.target.value.replace(/\s{2,}/g, ' ');
            event.target.value = newValue;
            this[field] = newValue;
        }
    },

    mounted() {
        const fields = ['firstName', 'lastName', 'telephone'];

        Promise.all(
            fields.map(field => {
                return this.formValidator.setValue(field, this[field]).then(
                    () => this.hideError(field),
                    (error) => this.showError(field, error)
                );
            })
        ).then(() => {
            this.evaluateButtonStatus();
        });
    }


}
</script>
